(function () {
  function enhanceJudgeMeSummary() {
    /* ===== SUMMARY (4.87 / out of 5) ===== */
    const summary = document.querySelector(".jdgm-all-reviews__summary");
    if (summary) {
      const avg = summary.querySelector(".jdgm-all-reviews__summary-average");
      if (avg && !avg.dataset.split) {
        const text = avg.textContent.trim();
        const match = text.match(/^([\d.,]+)\s+(out of\s+\d+)/i);
        if (match) {
          avg.innerHTML = `
              <span class="jdgm-rating-value">${match[1]}</span>
              <span class="jdgm-rating-rest">${match[2]}</span>
            `;
          avg.dataset.split = "1";
        }
      }

      const starsBlock = summary.querySelector(
        ".jdgm-all-reviews__summary-stars",
      );
      if (starsBlock && !starsBlock.querySelector(".jdgm-stars-inner")) {
        const stars = starsBlock.querySelectorAll(".jdgm-star");
        if (stars.length) {
          const wrapper = document.createElement("div");
          wrapper.className = "jdgm-stars-inner";
          stars.forEach((star) => wrapper.appendChild(star));
          starsBlock.appendChild(wrapper);
        }
      }
    }

    /* ===== TABS + MOST RECENT IN ONE ROW ===== */
    const subtab = document.querySelector(".jdgm-subtab");
    const actions = document.querySelector(".jdgm-row-actions");

    if (subtab && actions) {
      if (!subtab.parentElement.classList.contains("jdgm-tabs-row")) {
        const wrapper = document.createElement("div");
        wrapper.className = "jdgm-tabs-row";

        subtab.parentNode.insertBefore(wrapper, subtab);
        wrapper.appendChild(subtab);
        wrapper.appendChild(actions);
      }
    }

    /* ===== PRODUCT TITLE + RATING IN ONE ROW ===== */
    document.querySelectorAll(".jdgm-rev").forEach((rev) => {
      if (rev.querySelector(".jdgm-prod-rating-row")) return;

      const product = rev.querySelector(".jdgm-row-product");
      const rating = rev.querySelector(".jdgm-row-rating");
      const content = rev.querySelector(".jdgm-rev__content");

      const toDelete = [
        ".jdgm-rev__title",
        ".jdgm-rev__custom-form",
        ".jdgm-rev__actions",
        ".jdgm-rev__transparency-badge-wrapper",
      ];
      toDelete.forEach((el) => rev.querySelector(el)?.remove());

      if (!product || !rating || !content) return;

      const wrapper = document.createElement("div");
      wrapper.className = "jdgm-prod-rating-row";
      content.prepend(wrapper);
      wrapper.append(product, rating);
    });
  }

  enhanceJudgeMeSummary();

  const observer = new MutationObserver(enhanceJudgeMeSummary);
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  window.addEventListener("load", () => {
    enhanceJudgeMeSummary();
    setTimeout(enhanceJudgeMeSummary, 500);
    setTimeout(enhanceJudgeMeSummary, 1500);
  });
})();

(function () {
  function setJudgeMeInitials() {
    document.querySelectorAll(".jdgm-rev").forEach((rev) => {
      const icon = rev.querySelector(".jdgm-rev__icon");
      const author = rev.querySelector(".jdgm-rev__author");

      if (!icon || !author) return;

      const name = author.textContent.trim();
      if (!name) return;

      const initials = name
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((word) => word[0].toUpperCase())
        .join("");
      icon.setAttribute("data-initials", initials);
    });
  }

  setJudgeMeInitials();

  const observer = new MutationObserver(setJudgeMeInitials);
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener("load", () => {
    setJudgeMeInitials();
    setTimeout(setJudgeMeInitials, 500);
    setTimeout(setJudgeMeInitials, 1500);
  });
})();
(function () {
  function moveJudgeMeFlagNextToName() {
    document.querySelectorAll(".jdgm-rev").forEach((rev) => {
      const author = rev.querySelector(".jdgm-rev__author");
      const flag = rev.querySelector(".jdgm-rev__location-country-flag-img");

      if (!author || !flag) return;
      if (flag.dataset.moved === "1") return;

      author.insertAdjacentElement("afterend", flag);
      flag.dataset.moved = "1";
    });
  }

  moveJudgeMeFlagNextToName();

  const observer = new MutationObserver(moveJudgeMeFlagNextToName);
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener("load", () => {
    moveJudgeMeFlagNextToName();
    setTimeout(moveJudgeMeFlagNextToName, 500);
    setTimeout(moveJudgeMeFlagNextToName, 1500);
  });
})();

(function () {
  function moveJudgeMeTimestampToProfile() {
    document.querySelectorAll(".jdgm-rev").forEach((rev) => {
      const profile = rev.querySelector(".jdgm-row-profile");
      const timestamp = rev.querySelector(".jdgm-rev__timestamp");

      if (!profile || !timestamp) return;
      if (timestamp.dataset.moved === "1") return;

      profile.appendChild(timestamp);
      timestamp.dataset.moved = "1";
    });
  }

  moveJudgeMeTimestampToProfile();

  const observer = new MutationObserver(moveJudgeMeTimestampToProfile);
  observer.observe(document.body, { childList: true, subtree: true });

  window.addEventListener("load", () => {
    moveJudgeMeTimestampToProfile();
    setTimeout(moveJudgeMeTimestampToProfile, 500);
    setTimeout(moveJudgeMeTimestampToProfile, 1500);
  });
})();
document.addEventListener("DOMContentLoaded", () => {
  const initReviewReadMore = () => {
    document.querySelectorAll(".jdgm-rev__body").forEach((body) => {
      if (body.dataset.readMoreReady === "true") return;

      const p = body.querySelector("p");
      if (!p) return;

      const lineHeight = parseFloat(window.getComputedStyle(p).lineHeight);
      const maxHeight = lineHeight * 5;

      if (p.scrollHeight <= maxHeight + 2) return;

      body.dataset.readMoreReady = "true";

      body.classList.add("is-clamped");

      const button = document.createElement("button");
      button.type = "button";
      button.className = "jdgm-review-toggle";
      button.textContent = "Read more";

      button.addEventListener("click", () => {
        body.classList.toggle("is-open");

        button.textContent = body.classList.contains("is-open")
          ? "Show less"
          : "Read more";
      });

      p.insertAdjacentElement("afterend", button);
    });
  };

  initReviewReadMore();
  setTimeout(initReviewReadMore, 800);
  setTimeout(initReviewReadMore, 2000);
});
